import { Component, OnInit, Input } from '@angular/core';
import { AlertBannerService, AlertType } from "../../lib/alert-banner";
import { OrganisationService } from "../../services/organisation/organisation.service";
import * as Cookies from "js-cookie";
import { ConstantsService, ConstantsService as constants } from "../../services/constants/constants.service";
import { PermissionsService } from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-exit-details',
  templateUrl: './exit-details.component.pug',
  styleUrls: ['./exit-details.component.scss'],
  standalone: false
})
export class ExitDetailsComponent implements OnInit {
  @Input() data: any;
  org_uid = Cookies.get(constants.ORG_COOKIE);
  org: any;
  constructor(private alertList: AlertBannerService,
    private organisationService: OrganisationService,
    private permission: PermissionsService,
    private constant: ConstantsService) { }

  ngOnInit(): void {
    this.updateLeaveReason();
    this.organisationService.getOrganisation().subscribe(res => {
      this.org = res;
      },
        (err: any) => {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        })
  }

  updateLeaveReason() {
    this.data = {
      ...this.data,
      reason_for_leaving: this.constant.reasonsMap[this.data.reason_for_leaving] ?? this.data.reason_for_leaving
    }
  }
}
